import { createSagaAction } from 'saga-toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { UserState } from './types';
import { PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

const sliceName = 'user';

export const initialState: UserState = {
  loading: false,
  accessToken: '',
  refreshToken: '',
  expirationDate: '',
  email: '',
  name: '',
};

interface loginUserActionPayload {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  email: string;
  name?: string;
}
export const registerUserAction = createSagaAction(`${sliceName}/registerUser`);
export const loginUserAction = createSagaAction(`${sliceName}/loginUser`);
export const refreshTheAccesTokenAction = createSagaAction(
  `${sliceName}/refreshTheAccesToken`,
);
export const getBillingInfoAction = createSagaAction(
  `${sliceName}/getBillingInfo`,
);

export const userSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    addUserData: (state, action: PayloadAction<loginUserActionPayload>) => {
      const { access_token, refresh_token, expires_in, email, name } =
        action.payload;
      state.accessToken = access_token;
      state.refreshToken = refresh_token;
      const endTime: string = DateTime.now()
        .plus({ seconds: expires_in })
        .toISO();
      state.expirationDate = endTime;
      state.email = email;
      state.name = name || '';
    },
    updateTokensAction: (
      state,
      action: PayloadAction<{
        accesToken: string;
        refreshToken: string;
        expires_in: number;
      }>,
    ) => {
      state.accessToken = action.payload.accesToken;
      state.refreshToken = action.payload.refreshToken;
      const endTime: string = DateTime.now()
        .plus({ seconds: action.payload.expires_in })
        .toISO();
      state.expirationDate = endTime;
    },
    logoutUserAction: () => initialState,
  },
  extraReducers: {
    [registerUserAction.pending]: state => {
      state.loading = true;
    },
    [registerUserAction.fulfilled]: state => {
      state.loading = false;
    },
    [registerUserAction.rejected]: state => {
      state.loading = false;
    },
    [loginUserAction.pending]: state => {
      state.loading = true;
    },
    [loginUserAction.fulfilled]: state => {
      state.loading = false;
    },
    [loginUserAction.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  actions: { addUserData, updateTokensAction, logoutUserAction },
} = userSlice;

export default userSlice.reducer;
